import { Route } from '@angular/router';
import { supporterFeedbackResolver } from '@formunauts/supporter-feedback/data-access';
import {
  SupportFeedbackNotFoundComponent,
  SupporterFeedbackFormComponent,
} from '@formunauts/supporter-feedback/feature';

export const appRoutes: Route[] = [
  { path: 'not-found', component: SupportFeedbackNotFoundComponent },
  {
    path: '**',
    component: SupporterFeedbackFormComponent,
    resolve: { donorFeedbackResult: supporterFeedbackResolver },
  },
];
